import React, { useEffect, useState } from "react";

const initialForm = {
  structureName: "",
  department: "",
  description: "",
  components: [],
  status: "Active",
};

export default function SalaryStructureModal({
  isOpen,
  onClose,
  onSave,
  initialData,
  salaryComponents,
  departments,
}) {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialForm);
    }
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const handleCheckbox = (componentName) => {
    setFormData((prev) => {
      const exists = prev.components.includes(componentName);

      if (exists) {
        return {
          ...prev,
          components: prev.components.filter(
            (item) => item !== componentName
          ),
        };
      }

      return {
        ...prev,
        components: [...prev.components, componentName],
      };
    });
  };

  const handleSubmit = () => {
    if (!formData.structureName.trim()) {
      alert("Structure Name is required");
      return;
    }

    if (!formData.department) {
      alert("Department is required");
      return;
    }

    if (formData.components.length === 0) {
      alert("Select at least one salary component");
      return;
    }

    onSave(formData);
  };

  return (
    <div className="modal-overlay">
      <div
        className="finance-modal"
        style={{ width: "800px", maxWidth: "95%" }}
      >
        <div className="finance-modal-header">
          <h2>
            {initialData
              ? "Edit Salary Structure"
              : "Create Salary Structure"}
          </h2>
        </div>

        <div className="finance-modal-body">

          <div className="form-group">
            <label>Structure Name *</label>

            <input
              className="finance-input"
              value={formData.structureName}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  structureName: e.target.value,
                })
              }
            />
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Department *</label>

              <select
                className="finance-select"
                value={formData.department}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    department: e.target.value,
                  })
                }
              >
                <option value="">Select</option>

                {departments.map((dept) => (
                  <option key={dept}>
                    {dept}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Status</label>

              <select
                className="finance-select"
                value={formData.status}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    status: e.target.value,
                  })
                }
              >
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>

          </div>

          <div className="form-group">
            <label>Description</label>

            <textarea
              rows="3"
              className="finance-input"
              value={formData.description}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  description: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group">
            <label>Salary Components</label>

            <div className="component-checkbox-grid">

              {salaryComponents.map((component) => (
                <label
                  key={component.id}
                  className="component-checkbox"
                >
                  <input
                    type="checkbox"
                    checked={formData.components.includes(
                      component.componentName
                    )}
                    onChange={() =>
                      handleCheckbox(component.componentName)
                    }
                  />

                  {component.componentName}
                </label>
              ))}

            </div>
          </div>

        </div>

        <div className="finance-modal-footer">
          <button
            className="finance-secondary-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="finance-primary-btn"
            onClick={handleSubmit}
          >
            Save Structure
          </button>
        </div>
      </div>
    </div>
  );
}